/*####### jquery-validate-config.js - v1.0 - 1.12.2017 - for motorsport v6 #######*/

export const formValidateConfig = {
    ready: true,
    translate(alias, defaultt){
        return 'translate' in window ? window.translate(alias, defaultt) : (defaultt || alias);
    },
    init(options){
        if(!formValidateConfig.ready) return;

        const forms = options.forms || {};
        
        $.validator.setDefaults({
            onkeyup: false,
            focusCleanup: false,
            focusInvalid: true,
            errorPlacement: function($error, $element) {
                var $parent = $element.parent();
                if($parent.is('label')){
                    var $err = $parent.next();
                    if($err.is('.error')){
                        $err.html($error);
                    }else{
                        $error.insertAfter($parent);
                    }
                }else{
                    $error.insertAfter($element);
                }
                if($element.is('.bubbleError')){
                    $error.wrap('<div class="errorBubble"></div>');
                }
            },
            errorElement: 'div',
            submitHandler: function(){

                var validator = this,
                    $form = $(validator.currentForm);
                if($form.attr('method').toLowerCase() == 'get'){
                    var a = [],
                        $elements = $form.find("input, select, textarea").not(':submit, :reset, :image, [disabled], [name="send"], [data-ignor]');

                    $elements.each(function() {
                        var n = this.name;
                        if (!n) {
                            return;
                        }
                        var v = $.fieldValue(this);
                        if (v && v.constructor == Array) {
                            for (var i=0,max=v.length; i < max; i++) {
                                a.push({name: n, value: v[i]});
                            }
                        }
                        else if ($.trim(v) !== "" && v !== null && typeof v != 'undefined') {
                            a.push({name: this.name, value: v});
                        }
                    });
                    var url = $form.attr('action');
                    if(url){
                        if($form.data('params-strickt') && !a.length){
                            return;
                        }
                        
                        if(a.length){
                            var qs = $.param(a);
                            url = url.indexOf('?') < 0 ? url + '?' + qs : url + '&' + qs;
                        }
                        if('goToUrl' in window){                  
                            goToUrl(url);
                        }else{
                            window.location = url;
                        }
                    }

                }else{
                    var $submit = $(validator.submitButton), //$form.find(':submit')
                        formId = $form.attr('id'),
                        config = (forms && forms.config && forms.config[formId] ? forms.config[formId] : {}),
                        options = {};


                    if($submit.is('.wait') || $submit.is('.disabled')){
                        return false;
                    }
                    options.beforeSubmit = config.beforeSubmit && typeof config.beforeSubmit == 'function' ? config.beforeSubmit : function(){
                        $submit.addClass('wait');
                    }

                    options.success = (config.success && typeof config.success == 'function' ? config.success : function(response){
                        $submit.removeClass('wait');
                        if(response && response.constructor === Object){
                            var messageType = 'message',
                                delay = 10;
                            if(response.status){
                                if(forms && forms.statusTrue && forms.statusTrue[formId] && typeof forms.statusTrue[formId] == 'function'){
                                    forms.statusTrue[formId].call(this, $form, validator, response);
                                } 
                            }else{
                                messageType = 'error';
                                delay = 20;
                                if(forms && forms.statusFalse && forms.statusFalse[formId] && typeof forms.statusFalse[formId] == 'function'){
                                    forms.statusFalse[formId].call(this, $form, validator, response);
                                } 
                            }
                            var messageText = false;
                            if(response.message){
                                messageText = response.message;
                            } else if(response.messages && response.messages.length){
                                var msg = '<ul>';
                                for(var i = 0, c = response.messages.length; i < c; i++){
                                    msg += '<li>' + response.messages[i] + '</li>';
                                }
                                msg += '</ul>';
                                messageText = msg;
                                
                            }                    
                            if(!config.preventUrl && "url" in response && 'goToUrl' in window){
                                if('localStorage' in window && messageText){
                                    localStorage['cmpTrayAlertMessage'] = messageText;
                                    localStorage['cmpTrayAlertType'] = messageType;
                                    localStorage['cmpTrayAlertDelay'] = delay;
                                }
                                goToUrl(response.url);
                            }else{
                                if(!config.preventAlert){
                                    if(messageText){
                                        cmpTrayAlert.show(messageText, messageType, delay);
                                    }
                                }                     
                            }
                        }else{
                            cmpTrayAlert.show(window.translate('message_something_went_wrong', 'Error'), 'error', 30);
                        }
                        $form.trigger('reset');
                    }); 
                    options.error = function(jqXHR){
                        $submit.removeClass('wait');
                        if(jqXHR.responseJSON && jqXHR.responseJSON.constructor === Object && jqXHR.responseJSON.message){
                            cmpTrayAlert.show(jqXHR.responseJSON.message, 'error', 30);
                        }
                    }
                    options.cache = config.cache || false;
                    if(config.dataType){
                        options.dataType = config.dataType;
                    }
                    if(config.data){
                        options.data = config.data;
                    }else{
                        options.data = {};
                    }
                    
                    if(config.clearForm){
                        options.clearForm = config.clearForm;
                    }
                    if(config.error && typeof config.error == 'function'){
                        options.error = config.error;
                    }
                    if(config.resetForm){
                        options.resetForm = config.resetForm;
                    }
                    if(config.type){
                        options.type = config.type;
                    }
                    if(config.url){
                        options.url = config.url;
                    }
                    if($submit.data('formClose')){
                        options.data.formClose = 1;
                    }
                    $form.ajaxSubmit(options);
                }
            }
        });
        var _self = this;
        $.extend($.validator.messages, {
            required: _self.translate('message_field_required', "This field is required!"),
            remote: _self.translate('message_fix_this_field', "Please fix this field."),
            email: _self.translate('message_enter_ valid_email', "Please enter a valid email address."),
            url: _self.translate('message_enter_valid_url', "Please enter a valid URL."),
            date: _self.translate('message_enter_valid_date', "Please enter a valid date."),
            dateISO: _self.translate('message_enter_valid_date_iso', "Please enter a valid date (ISO)."),
            number: _self.translate('message_enter_valid_number', "Please enter a valid number."),
            digits: _self.translate('message_enter_only_digits', "Please enter only digits."),
            creditcard: _self.translate('message_enter_valid_credit_card_number', "Please enter a valid credit card number."),
            equalTo: _self.translate('message_enter_same_value_again', "Please enter the same value again."),
            accept: _self.translate('message_enter_value_with_valid_extension', "Please enter a value with a valid extension."),
            regex: _self.translate('message_enter_valid_value', "Please enter a valid value."),
            imgsize: _self.translate('message_select_image_with_dimentions', "Please select image with dimentions {0}."),
            maxlength: $.validator.format(_self.translate('message_enter_no_more_than_characters', "Please enter no more than {0} characters.")),
            minlength: $.validator.format(_self.translate('message_enter_at_least_characters', "Please enter at least {0} characters.")),
            rangelength: $.validator.format(_self.translate('message_enter_value_between_characters_long', "Please enter a value between {0} and {1} characters long.")),
            range: $.validator.format(_self.translate('message_enter_value_between', "Please enter a value between {0} and {1}.")),
            max: $.validator.format(_self.translate('message_enter_value_less_than_or_equal_to', "Please enter a value less than or equal to {0}.")),
            min: $.validator.format(_self.translate('message_enter_value_greater_than_or_equal_to', "Please enter a value greater than or equal to {0}."))
        });

        $.validator.addMethod('regex', function(value, element, param) {
            var re = new RegExp(param);
            return this.optional(element) || re.test(value);
        }, $.validator.messages.regex);


        /*$.validator.addMethod("extension", function(value, element, param) {
            param = typeof param === "string" ? param.replace(/,/g, '|') : "png|jpe?g|gif";
            return this.optional(element) || value.match(new RegExp(".(" + param + ")$", "i"));
        }, $.validator.format(translate('mesaage_no_valid_files')));

        $.validator.addMethod('imgsize', function(value, element, param) {
            var fileReader,
                dimentions,
                $element;

            if ( this.optional(element) )
                return "dependency-mismatch";

            if ( this.pending[element.name] ) {
                return "pending";
            }

            var validator = this;

            // if browser doesn't support FileReader we cannot get image dimentions to test
            if (!('FileReader' in window)) {
                return true;
            }


            $element = $(element);
            dimentions = param.split('x');
            fileReader = new FileReader();

            fileReader.onload = function (fileData) {
                var img = new Image();

                img.addEventListener('load', function() {
                    var width = img.width,
                        height = img.height,
                        errors = {};

                    if (dimentions[0] != width || dimentions[1] != height) {
                        errors[$element.attr('name')] = $.validator.messages.imgsize.replace('{0}', param);
                        validator.showErrors(errors);
                    } else {
                        var submitted = validator.formSubmitted;
                        validator.prepareElement(element);
                        validator.formSubmitted = submitted;
                        validator.successList.push(element);
                        validator.showErrors();
                    }
                }, false);

                img.src = fileData.target.result;
            };

            fileReader.readAsDataURL(element.files[0]);

            return 'pending';
        }, $.validator.messages.imgsize);*/

    }
}